export default __webpack_public_path__ + "static/transportation-accomplishment-1b-3915a99a85ff95ef73186e8af937ed3c.webp";